/*
 * Show the chosen Bundle Panda tier's price inside the add-to-cart button.
 *
 * The app renders "1 Stuk / 2 Stuk / 3 Stuk" offers in #offers-list-container-*, marking the
 * chosen tier with a 2px border (inline style) and showing each tier's price (.pb-ca09) and
 * original price (.pb-0993). On a product with those offers, the add-to-cart button (and the
 * sticky bar's button) carries the chosen tier's price with the original struck through, and the
 * page's own price block is hidden through the pb-bundle-active class on <html>.
 *
 * Products without offers are left alone. The app's class names are hashed; if an app update
 * renames them this script finds no tiers, removes the class and the price block comes back.
 */
(() => {
  const OFFERS = "[id^='offers-list-container']";
  const TIER = '.pb-aac6';
  const TIER_PRICE = '.pb-ca09';
  const TIER_COMPARE = '.pb-0993';
  const ACTIVE = 'pb-bundle-active';
  const SLOT = 'pb-atc-price';

  // "€ 64,95" -> 64.95
  const toNumber = (text) => {
    const cleaned = (text || '').replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    const value = parseFloat(cleaned);
    return Number.isFinite(value) ? value : null;
  };

  const tidy = (text) => (text || '').replace(/\s+/g, ' ').replace(/€\s+/, '€').trim();

  const escape = (text) =>
    text.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  function selectedTier(offers) {
    const tiers = [...offers.querySelectorAll(TIER)];
    const index = tiers.findIndex((tier) => /border-width:\s*2px/.test(tier.getAttribute('style') || ''));
    return index === -1 ? null : { tier: tiers[index], index };
  }

  // The single-item tier lists no original price; the theme's own price block knows it.
  function themeCompare() {
    const el = document.querySelector(
      '.product-details product-price .price__sale:not(.price__hidden) .compare-at-price'
    );
    return tidy(el?.textContent);
  }

  // The main button sits next to the offers; the sticky bar has its own.
  function buttons(offers) {
    const main = offers.closest('add-to-cart-component')?.querySelector('button[name="add"]');
    const sticky = document.querySelector('.sticky-add-to-cart__button');
    return [main, sticky].filter(Boolean);
  }

  function clear(offers) {
    document.documentElement.classList.remove(ACTIVE);
    buttons(offers).forEach((button) => button.querySelector('.' + SLOT)?.remove());
  }

  function render(offers) {
    const selected = selectedTier(offers);
    const price = tidy(selected?.tier.querySelector(TIER_PRICE)?.textContent);
    if (!price) return clear(offers);

    let compare = tidy(selected.tier.querySelector(TIER_COMPARE)?.textContent);
    if (!compare && selected.index === 0) compare = themeCompare();

    const priceValue = toNumber(price);
    const compareValue = toNumber(compare);
    const hasCompare = priceValue !== null && compareValue !== null && compareValue > priceValue;

    const html =
      `<span class="${SLOT}__now">${escape(price)}</span>` +
      (hasCompare ? `<s class="${SLOT}__was">${escape(compare)}</s>` : '');

    document.documentElement.classList.add(ACTIVE);
    buttons(offers).forEach((button) => {
      const text = button.querySelector('.add-to-cart-text');
      if (!text) return;
      let slot = text.querySelector('.' + SLOT);
      if (!slot) {
        slot = document.createElement('span');
        slot.className = SLOT;
        text.append(slot);
      }
      // Only write on a real change, so the observers below do not loop.
      if (slot.innerHTML !== html) slot.innerHTML = html;
    });
  }

  function watch(offers) {
    if (offers._pbWatched) return;
    offers._pbWatched = true;
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => render(offers));
    };
    new MutationObserver(schedule).observe(offers, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    offers.addEventListener('click', () => setTimeout(schedule, 0));

    // The theme rewrites the button label on variant changes, which drops the price slot.
    const observed = new WeakSet();
    const watchButtons = () =>
      buttons(offers).forEach((button) => {
        if (observed.has(button)) return;
        observed.add(button);
        new MutationObserver(schedule).observe(button, { subtree: true, childList: true });
      });
    watchButtons();
    setTimeout(watchButtons, 1500);
    schedule();
  }

  // The app renders its offers after the page loads, so wait for the container to appear.
  const find = () => document.querySelectorAll(OFFERS).forEach(watch);
  find();
  new MutationObserver(find).observe(document.documentElement, { childList: true, subtree: true });
})();
